import {
  KeyboardEvent,
  LegacyRef,
  SyntheticEvent,
  useCallback,
  useRef,
  useState
} from "react"

import useOnOutsideClick from "../../hooks/useOnOutsideClick"

export const useDropdown = () => {
  const parentElementRef: LegacyRef<HTMLDivElement> = useRef(null)
  const [showMenu, setShowMenu] = useState(false)
  const handleOutsideClick = useCallback(() => setShowMenu(false), [])

  useOnOutsideClick(parentElementRef, handleOutsideClick)

  const handleShowMenu = (show: boolean) => (e: SyntheticEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setShowMenu(show)
  }

  const keyboardHandler = (e: KeyboardEvent<HTMLDivElement>) => {
    e.preventDefault()
    if (e.key === "Escape") {
      setShowMenu(false)
    }
  }

  return {
    showMenu,
    handleShowMenu,
    keyboardHandler,
    parentElementRef
  }
}
